import ICAL from 'ical.js';
import { ICal } from './ical';
import { ICalEvent } from './ical-event';
import icalEventService from './ical-event.service';


export function create(values?: Partial<ICal>): ICal {
	return {
		UID: values?.UID ?? '',
		events: values?.events ?? [],
		version: '2.0',
		PRODID: 'app.timetime.in',
	};
}

function addEvent(cal: ICal, event: ICalEvent): ICal {
	return {
		...cal,
		events: [...cal.events, event],
	};
}

function toString(ical: ICal): string {
	const comp = new ICAL.Component(['vcalendar', [], []]);
	// Add basic information
	comp.updatePropertyWithValue('prodid', 'timetime.in');
	comp.updatePropertyWithValue('uid', ical.UID);
	comp.updatePropertyWithValue('version', ical.version);

	// Add all events
	ical.events.forEach(e => {
		comp.addSubcomponent(icalEventService.domainEventToIcalEvent(e).component);
	})

	return comp.toString();
}

export function parse(raw: string): ICal {
	const jCalData = ICAL.parse(raw);
	const calendar = new ICAL.Component(jCalData);

	const events = calendar.getAllSubcomponents('vevent').map(vevent => {
		const e = new ICAL.Event(vevent);
		return e;

	}).map(raw => {
		const parsed = icalEventService.icalEventToDomainEvent(raw);
		return parsed
	})

	return {
		PRODID: calendar.getFirstPropertyValue('prodid') as string,
		UID: calendar.getFirstPropertyValue('uid') as string,
		version: '2.0',
		events,
	}
}



export default { addEvent, create, toString, parse };
